<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工：">
          <el-select v-model="formInline.userKeyId" placeholder="请选择人员" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in userList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：">
          <el-date-picker v-model="dateStr" type="month" value-format="yyyy-MM" format="yyyy年MM月" size="small"
            :clearable="false" @change="handleDateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button v-if="btnpermission.search" size="small" type="primary" class="el-icon-search"
            @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="btnpermission.create" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">
            新增
          </el-button>
          <el-button v-if="btnpermission.export" size="small" type="warning" class="el-icon-s-promotion"
            @click="handleExport()">
            导出
          </el-button>
        </el-form-item>
      </el-form>
      <el-table :data="listData" style="width: 100%;" border stripe :highlight-selection-row="true"
        @row-dblclick="handleEdit" empty-text="暂无数据" v-loading="loading" row-key="keyId" height="600px"
        :header-cell-style="{ backgroundColor: '#b3e0ff' }">
        <el-table-column align="center" prop="rowNumber" label="序号" width="60" fixed="left"></el-table-column>
        <el-table-column align="center" prop="storeName" label="门店名称" width="100" fixed="left"></el-table-column>
        <el-table-column align="center" prop="yearMonth" label="年月" min-width="120" fixed="left">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handleShowDetail(scope.row)">
              {{ scope.row.year }}年{{ scope.row.month }}月
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="userInfo.chName" label="员工" width="100" fixed="left"></el-table-column>
        <el-table-column align="center" prop="userInfo.createTime" label="入职时间" width="120" fixed="left">
          <template slot-scope="scope">
            {{ scope.row.userInfo.createTime.substring(0, 10) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isConfirm" label="是否确认" width="100" fixed="left">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isConfirm === 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="基础工资">
          <el-table-column align="center" prop="baseSalary" label="基础薪资" width="90"></el-table-column>
          <el-table-column align="center" prop="perfectAttendance" label="全勤" width="80"></el-table-column>
          <el-table-column align="center" label="应发基本工资" width="80">
            <template slot-scope="scope">
              {{ scope.row.baseSalary + scope.row.perfectAttendance }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="postWage" label="岗位薪资" width="90"></el-table-column>
          <el-table-column align="center" prop="socialSecuritySubsidy" label="社保补贴" width="90"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="提成">
          <el-table-column align="center" prop="cardBonus" label="充卡提成" width="90">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 1)">
                {{ scope.row.cardBonus }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="notCardBonus" label="销售提成" width="90">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 2)">
                {{ scope.row.notCardBonus }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="phoneBonus" label="电话提成(销售20%部分)" width="90">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 3)">
                {{ scope.row.phoneBonus }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="paoDanBonus" label="跑单提成" width="90">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 4)">
                {{ scope.row.paoDanBonus }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="chengJiaoBonus" label="进店成交提成" width="90">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 5)">
                {{ scope.row.chengJiaoBonus }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="schoolBonus" label="学校提成" width="90"></el-table-column>
          <el-table-column align="center" label="提成合计" width="90">
            <template slot-scope="scope">
              {{ scope.row.notCardBonus + scope.row.cardBonus + scope.row.phoneBonus + scope.row.schoolBonus +
                scope.row.paoDanBonus + scope.row.chengJiaoBonus }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="其他">
          <el-table-column align="center" prop="subtractMoney" label="应扣除金额" width="80"></el-table-column>
          <el-table-column align="center" prop="seniorityPay" label="工龄" width="80"></el-table-column>
          <el-table-column align="center" prop="finishedMoney" label="目标达成奖励" width="80"></el-table-column>
          <el-table-column align="center" prop="reissueMoney" label="应补发金额" width="80"></el-table-column>
          <el-table-column align="center" prop="salesIncreasing" label="销售递增奖励" width="80"></el-table-column>
        </el-table-column>
        <el-table-column align="center" prop="realMoeny" label="实发总计" width="90"></el-table-column>
        <el-table-column align="center" prop="remark" label="备注" width="150"></el-table-column>
        <el-table-column align="center" prop="creator" label="创建人" width="90"></el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间" width="180"></el-table-column>
        <!-- 确认人和确认时间 -->
        <el-table-column align="center" prop="confirmUserName" label="确认人" width="90"></el-table-column>
        <el-table-column align="center" prop="confirmTime" label="确认时间" width="180"></el-table-column>
        <!-- 操作列 -->
        <el-table-column align="center" label="操作" width="270" fixed="right">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="确认工资" placement="top">
              <el-button v-if="scope.row.isConfirm === false && btnpermission.confirm" size="small" type="primary"
                class="el-icon-check" @click="handleConfirm(scope.row)">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="更新基本工资" placement="top">
              <el-button v-if="scope.row.isConfirm === false && btnpermission.updateBaseSalary" size="small"
                type="primary" class="el-icon-refresh" @click="handleUpdateBaseSalary(scope.row)">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="更新提成" placement="top">
              <el-button v-if="scope.row.isConfirm === false && btnpermission.updateBonus" size="small" type="warning"
                class="el-icon-refresh" @click="handleUpdateBonus(scope.row)">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <el-button v-if="scope.row.isConfirm === false && btnpermission.delete" size="small" type="danger"
                class="el-icon-delete" @click="handleDelete(scope.row)">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 编辑界面 -->
    <edit ref="edit"></edit>
    <!-- 详情界面 -->
    <detail ref="detail"></detail>
    <!-- 提成记录弹窗 -->
    <commissionRecord ref="commissionRecord"></commissionRecord>
  </div>
</template>

<script>
import {
  GetUserMonthSalaryPageList,
  ExportUserMonthSalary,
  ConfirmUserMonthBaseSalary,
  UpdateUserMonthBonus,
  UpdateUserMonthBaseSalary,
  DeleteUserMonthSalary
} from "@/api/salaryApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import {
  GetUserBindSelectByPermission
} from "@/api/userApi.js";
import { downloadFile } from "@/utils/export.js";
import edit from "@/views/accounting/salary/monthSalary/edit.vue";
import detail from "@/views/accounting/salary/monthSalary/detail.vue";
import commissionRecord from "@/views/accounting/storeCost/commission/recordDialog.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "员工月度工资",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      dateStr: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 15,
        storeKeyId: "",
        userKeyId: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      storeList: [],
      userList: [],
      btnpermission: {
        search: false,
        create: false,
        export: false,
        update: false,
        confirm: false,
        updateBaseSalary: false,
        delete: false,
        updateBonus: false,
      },
    };
  },
  // 注册组件
  components: {
    edit,
    detail,
    commissionRecord
  },
  created() {
    this.getUserBtnPermission();
    this.getListData();
    this.GetOrgInfoListByConfig();
    this.GetUserBindSelectByPermission();
  },
  computed: {},
  methods: {
    changePages() { },
    //检测权限
    getUserBtnPermission() {
      this.btnpermission.search = this.$checkBtnPermission('/monthSalary/index', 'viewPage');
      this.btnpermission.create = this.$checkBtnPermission('/monthSalary/index', 'create');
      this.btnpermission.export = this.$checkBtnPermission('/monthSalary/index', 'export');
      this.btnpermission.update = this.$checkBtnPermission('/monthSalary/index', 'update');
      this.btnpermission.confirm = this.$checkBtnPermission('/monthSalary/index', 'confirm');
      this.btnpermission.updateBaseSalary = this.$checkBtnPermission('/monthSalary/index', 'updateBaseSalary');
      this.btnpermission.delete = this.$checkBtnPermission('/monthSalary/index', 'delete');
      this.btnpermission.updateBonus = this.$checkBtnPermission('/monthSalary/index', 'updateBonus');
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取人员信息绑定下拉框_根据权限
    GetUserBindSelectByPermission() {
      const paramer = {};
      GetUserBindSelectByPermission(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.userList = [];
            if (res.code == 1) {
              this.userList = res.data;
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取人员信息失败!");
        });
    },
    // 获取列表
    getListData() {
      if (!this.btnpermission.search) {
        this.$message({
          type: "info",
          message: "您没有查询权限，请联系管理员！",
        });
        return;
      }
      this.loading = true;
      GetUserMonthSalaryPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 日期选择器事件
    handleDateChange(val) {
      if (val.length > 0) {
        var list = val.split('-');
        this.formInline.year = parseInt(list[0]);
        this.formInline.month = parseInt(list[1]);
      } else {
        this.formInline.year = new Date().getFullYear();
        this.formInline.month = new Date().getMonth() + 1;
      }
      this.getListData();
    },
    // 新增
    handleEdit(row) {
      if (row != undefined && row != "undefined") {
        if (!this.btnpermission.update) {
          this.$message({
            type: "info",
            message: "您没有更新权限，请联系管理员！",
          });
          return;
        }
      }
      else {
        if (!this.btnpermission.create) {
          this.$message({
            type: "info",
            message: "您没有新增权限，请联系管理员！",
          });
          return;
        }
      }
      this.$refs.edit.editShow(row);
    },
    // 详情
    handleShowDetail(row) {
      this.$refs.detail.detailShow(row);
    },
    // 提成记录弹窗
    handleShowCommissionList(row, type) {
      this.$refs.commissionRecord.showCommissionReord(row, type);
    },
    // 导出
    handleExport() {
      if (!this.btnpermission.export) {
        this.$message({
          type: "info",
          message: "您没有导出权限，请联系管理员！",
        });
        return;
      }
      this.$confirm("确定导出所选筛选条件查询出来的月工资信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ExportUserMonthSalary(this.formInline)
          .then((res) => {
            if (res.code === 1) {
              let fileName = res.data
                ? res.data.substring(res.data.lastIndexOf("/") + 1)
                : "员工月工资清单.xlsx";
              downloadFile(res.data, fileName);
              this.$message({
                type: "success",
                message: "导出成功!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("导出失败，请稍后再试！");
          });
      });
    },
    // 确认
    handleConfirm(row) {
      this.$confirm("确定确认该月工资吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ConfirmUserMonthBaseSalary({
          keyId: row.keyId
        })
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "确认成功!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("确认失败，请稍后再试！");
          });
      });
    },
    // 更新员工月工资的提成
    handleUpdateBonus(row) {
      if (!this.btnpermission.update) {
        this.$message({
          type: "info",
          message: "您没有更新权限，请联系管理员！",
        });
        return;
      }
      this.$confirm("确定更新该月工资的提成吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        UpdateUserMonthBonus({
          keyId: row.keyId
        })
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "更新成功!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("更新失败，请稍后再试！");
          });
      });
    },
    // 更新员工月工资的基本工资信息
    handleUpdateBaseSalary(row) {
      if (!this.btnpermission.update) {
        this.$message({
          type: "info",
          message: "您没有更新权限，请联系管理员！",
        });
        return;
      }
      this.$confirm("确定更新该月工资的基本工资吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        UpdateUserMonthBaseSalary({
          keyId: row.keyId
        })
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "更新成功!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("更新失败，请稍后再试！");
          });
      });
    },
    // 删除
    handleDelete(row) {
      if (!this.btnpermission.delete) {
        this.$message({
          type: "info",
          message: "您没有删除权限，请联系管理员！",
        });
        return;
      }
      this.$confirm("确定删除该月工资吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        DeleteUserMonthSalary({
          keyId: row.keyId
        })
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("删除失败，请稍后再试！");
          });
      });
    },
  },
};
</script>

<style scoped></style>